import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PieChartComponent from './_pie_chart_category';
import BarChartComponent from './_bar_chart_category';
import dummyReportData from './_dummy_data';
import dummyBarChartData  from './_dummy_bar_data';

const CategoryCharts = ({ reportData }) => {
  return (
    <Row className="mt-2">
      <Col md={6} className="mb-4">
        <PieChartComponent reportData={dummyReportData} />
      </Col>
      <Col md={6} className="mb-4">
        <BarChartComponent reportData={dummyBarChartData} />
      </Col>
    </Row>
  );
};

export default CategoryCharts;